import { createContext } from "react";

import { UserPlatformRole } from "@/types/user.types";

type UserRolesContextValueType = {
  platformRole: UserPlatformRole | null;
  loading: boolean;
  isError: boolean;
};

export const UserRolesContext = createContext<UserRolesContextValueType>({
  platformRole: null,
  loading: false,
  isError: false,
});
